// src/services/chartService.js - SECURED
import { API_BASE_URL } from '../utils/constants';

const getAuthHeaders = () => {
  return {
    'Content-Type': 'application/json',
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    if (response.status === 401) {
      window.location.href = '/';
    }
    const error = await response.json();
    throw new Error(error.error || error.detail || 'Request failed');
  }
  return response.json();
};

export const chartService = {
  // Get list of all available stocks for charting
  async getAvailableStocks() {
    try {
      const response = await fetch(`${API_BASE_URL}/chart/stocks/`, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching available stocks:', error);
      throw error;
    }
  },

  // Get chart data for a specific stock
  async getChartData(symbol, interval = '1hr', limit = 100) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/chart/stocks/${symbol}/chart/?interval=${interval}&limit=${limit}`,
        {
          method: 'GET',
          headers: getAuthHeaders(),
          credentials: 'include',
        }
      );
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching chart data:', error);
      throw error;
    }
  },

  // Get current price for a stock
  async getCurrentPrice(symbol) {
    try {
      const response = await fetch(`${API_BASE_URL}/chart/stocks/${symbol}/price/`, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching current price:', error);
      throw error;
    }
  },

  // Get user's chart settings
  async getChartSettings() {
    try {
      const response = await fetch(`${API_BASE_URL}/chart/settings/`, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      return handleResponse(response);
    } catch (error) {
      console.error('Error fetching chart settings:', error);
      throw error;
    }
  },

  // Update user's chart settings
  async updateChartSettings(settings) {
    try {
      const response = await fetch(`${API_BASE_URL}/chart/settings/`, {
        method: 'POST',
        headers: getAuthHeaders(),
        credentials: 'include',
        body: JSON.stringify(settings),
      });
      return handleResponse(response);
    } catch (error) {
      console.error('Error updating chart settings:', error);
      throw error;
    }
  }
};